import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=31524daa&scoped=true&"
import script from "./UserManagement.vue?vue&type=script&lang=ts&"
export * from "./UserManagement.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=31524daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31524daa",
  null
  
)

export default component.exports